// extracted by mini-css-extract-plugin
export default {"movableContent":"anpUaH","content":"bnpUaH","noOverflow":"cnpUaH","animate":"dnpUaH"};